<template>
    <div class="wrapper">
        <v-head></v-head>
        <section class="wrap-content el-col el-col-24">
            <div class="sidebar" :class="collapse ? 'sidebar-el-menu-collapse':'sidebar-el-menu'">
                <el-menu
                        :default-active="activeIndex"
                        :class="collapse ? 'sidebar-el-menu-collapse':'sidebar-el-menu'"
                        :collapse="collapse"
                        @select="handleSelect"
                        text-color="#303133"
                        :active-text-color="themeColor"
                        unique-opened
                        router
                >
                    <NavMenu :navMenus="menuList"></NavMenu>
                </el-menu>
            </div>

            <div class="grid-content-box" :class="{'grid-content-box-collapse':collapse}">
                <v-tags></v-tags>
                <div class="home-grid-content">
                    <transition name="move" mode="out-in">
                        <keep-alive :include="tagsList">
                            <router-view></router-view>
                        </keep-alive>
                    </transition>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    import vHead from './Header.vue';
    // import vSidebar from './Sidebar.vue';
    import NavMenu from './Sidebar.vue';
    import vTags from './Tags.vue';
    import bus from './bus';
    import {mapGetters} from 'vuex'

    export default {
        data() {
            return {
                activeIndex: '/home',
                tagsList: [],
                collapse: false,

            }
        },
        components: {
            vHead, NavMenu, vTags
        },
        computed: {
            ...mapGetters({
                menuList: 'menu/menuList',
                themeColor: 'app/themeColor'
            }),
        },
        created() {
            this.handleSelect(this.$route.path);
            bus.$on('collapse', msg => {
                this.collapse = msg;
            })

            // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
            bus.$on('tags', msg => {
                let arr = [];
                for (let i = 0, len = msg.length; i < len; i++) {
                    msg[i].name && arr.push(msg[i].name);
                }
                this.tagsList = arr;
            })
        },
        methods: {
            handleSelect(index, keyPath) {
                this.activeIndex = index;
            },
        },
        watch: {
            $route(to, from) {
                console.log("$route", to);
                this.handleSelect(to.path);
            }
        }
    }
</script>
<style scoped>
    @import '../../../assets/css/layout/home.css';
</style>

